
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SectionLayout from '@/components/SectionLayout';
import CTAButton from '@/components/CTAButton';
import CountdownTimer from '@/components/CountdownTimer';
import SpecialOfferEndedModal from '@/components/SpecialOfferEndedModal';
import { AspectRatio } from '@/components/ui/aspect-ratio';

const SpecialOffer = () => {
  // Create the target date for Saturday May 31st at 12am EST
  const targetDate = new Date('2025-05-31T05:00:00Z'); // 12am EST = 5am UTC

  return (
    <div className="min-h-screen flex flex-col">
      {/* SEO - Meta tags to prevent indexing */}
      <head>
        <title>AI Consulting Accelerator Special Offer | AskSpot</title>
        <meta name="robots" content="noindex, nofollow" />
      </head>
      
      {/* Special Offer Ended Modal */}
      <SpecialOfferEndedModal />
      
      <Navbar />
      
      <main className="flex-grow">
        {/* Hero Section with Headline */}
        <SectionLayout paddingY="pt-20 sm:pt-28 md:pt-32 pb-8 sm:pb-10 md:pb-12" backgroundColor="bg-white" backgroundPattern="dots" patternOpacity={10}>
          <div className="max-w-4xl mx-auto text-center px-4 sm:px-6">
            {/* Logo */}
            <div className="mb-6 sm:mb-8">
              <img src="/lovable-uploads/752e5d36-8289-4d8c-bc4e-e50d0fef8890.png" alt="AI Consulting Accelerator Logo" className="max-w-full h-auto mx-auto rounded-lg sm:rounded-xl shadow-md sm:shadow-lg hover:scale-105 transition-transform duration-300 max-h-[120px] sm:max-h-[150px] md:max-h-[180px]" />
            </div>
            
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-[#003a70] leading-tight lg:text-4xl">
              AI Consulting Accelerator Special Offer
            </h1>
            
            {/* Countdown Timer */}
            <div className="mb-8 sm:mb-10 md:mb-12">
              <CountdownTimer targetDate={targetDate} className="max-w-2xl mx-auto" />
            </div>
            
            {/* Loom Video */}
            <div className="mb-8 sm:mb-10 md:mb-12">
              <div className="w-full max-w-4xl mx-auto">
                <div className="rounded-lg sm:rounded-xl overflow-hidden shadow-md sm:shadow-lg">
                  <AspectRatio ratio={16 / 9.6}>
                    <iframe src="https://www.loom.com/embed/0bc368634b2c4b2bafc75c77952497f1?sid=cdd554c6-08f3-4d6a-be43-c59e699cbf6f" frameBorder="0" allowFullScreen className="w-full h-full"></iframe>
                  </AspectRatio>
                </div>
              </div>
            </div>
            
            {/* CTA Button */}
            <div className="mt-6 sm:mt-8">
              <CTAButton variant="primary" className="text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 w-full sm:w-auto" to="https://buy.stripe.com/cN2aIeaChdkm7bGcN7">
                Claim Special Offer
              </CTAButton>
            </div>
          </div>
        </SectionLayout>
      </main>
      
      <Footer />
    </div>
  );
};

export default SpecialOffer;
